var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-permiso-cargo-vacacion"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "grey lighten-2 text--info px-2 py-2" },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "px-1" },
                    [
                      _vm.getRuta() != _vm.getPersonaId()
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                color: "primary",
                                to: "/permisos/usuario"
                              }
                            },
                            [_c("v-icon", [_vm._v("arrow_back")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getRuta() == _vm.getPersonaId()
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                color: "primary",
                                to: "/permisos/usuario/" + _vm.getPersonaId()
                              }
                            },
                            [_c("v-icon", [_vm._v("arrow_back")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(" Crear solicitud de nuevo permiso ")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0 container-creacion",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-xs": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  items: _vm.tipo_permisos,
                                  "item-value": "id",
                                  "item-text": "descripcion",
                                  label: "Solicitar permiso",
                                  maxlength: "50",
                                  rules: _vm.$validate(["required"]),
                                  outline: "",
                                  clearable: "",
                                  required: ""
                                },
                                on: {
                                  change: function($event) {
                                    _vm.obtenerFechasIniciales(
                                      _vm.form.id_tipo_permiso
                                    ) &&
                                      _vm.verificarCompensacion(false) &&
                                      _vm.obtenerSubpermiso(
                                        _vm.form.id_tipo_permiso
                                      ) &&
                                      _vm.verificaCenso(
                                        _vm.form.id_tipo_permiso
                                      )
                                  }
                                },
                                model: {
                                  value: _vm.form.id_tipo_permiso,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_tipo_permiso", $$v)
                                  },
                                  expression: "form.id_tipo_permiso"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 44
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.tipo_subpermisos,
                                      "item-value": "id",
                                      "item-text": "descripcion",
                                      name: "id_tipo_subpermiso",
                                      label:
                                        "Condición o estado crítico de salud",
                                      autofocus: "",
                                      maxlength: "200",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.id_tipo_subpermiso,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_tipo_subpermiso",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_tipo_subpermiso"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 90
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.tipos_baja,
                                      "item-value": "descripcion",
                                      "item-text": "descripcion",
                                      label: "Tipo de baja",
                                      maxlength: "50",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.tipo_baja,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "tipo_baja", $$v)
                                      },
                                      expression: "form.tipo_baja"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 87 ||
                          _vm.form.id_tipo_permiso == 103
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Lugar de comisión ",
                                      maxlength: "100",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.lugar,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "lugar", $$v)
                                      },
                                      expression: "form.lugar"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 18
                        ? _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.list_causal_permiso_sin_goce,
                                      "item-value": "descripcion",
                                      "item-text": "descripcion",
                                      name: "id_causal",
                                      label:
                                        "Causal de acuerdo al ART. 15 RM 1111:",
                                      autofocus: "",
                                      maxlength: "200",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.causal_sin_goce,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "causal_sin_goce",
                                          $$v
                                        )
                                      },
                                      expression: "form.causal_sin_goce"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 87 ||
                          _vm.form.id_tipo_permiso == 104 ||
                          _vm.form.id_tipo_permiso == 96 ||
                          _vm.form.id_tipo_permiso == 103 ||
                          _vm.form.id_tipo_permiso == 101
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      label: "Motivo",
                                      type: "text",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      "auto-grow": "",
                                      rows: "2",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.verificarCompensacion(false)
                                      }
                                    },
                                    model: {
                                      value: _vm.form.motivo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "motivo", $$v)
                                      },
                                      expression: "form.motivo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 61
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de nacimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_nacimiento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "fecha_nacimiento",
                                          $$v
                                        )
                                      },
                                      expression: "form.fecha_nacimiento"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 61
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "time",
                                      label: "Hora de nacimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.hora_nacimiento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "hora_nacimiento",
                                          $$v
                                        )
                                      },
                                      expression: "form.hora_nacimiento"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 12
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de matrimonio",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_matrimonio,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "fecha_matrimonio",
                                          $$v
                                        )
                                      },
                                      expression: "form.fecha_matrimonio"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 6
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de fallecimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_fallecimiento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "fecha_fallecimiento",
                                          $$v
                                        )
                                      },
                                      expression: "form.fecha_fallecimiento"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 6
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "time",
                                      label: "Hora de fallecimiento",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerFechaSalidaYEntrada()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.hora_fallecimiento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "hora_fallecimiento",
                                          $$v
                                        )
                                      },
                                      expression: "form.hora_fallecimiento"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 45
                        ? _c(
                            "v-layout",
                            [
                              _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                                _c("h4", [_vm._v("Fechas programadas")])
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-select", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      items: _vm.capacitacion_censista,
                                      "item-value": "id",
                                      "item-text": "valor",
                                      name: "capacitacion_censista",
                                      label:
                                        "Seleccionar tipo de participación",
                                      autofocus: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: !_vm.primer_permiso_censo,
                                      readonly: !!_vm.primer_permiso_censo,
                                      disabled: !!_vm.primer_permiso_censo
                                    },
                                    model: {
                                      value: _vm.form.capacitacion_censista,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "capacitacion_censista",
                                          $$v
                                        )
                                      },
                                      expression: "form.capacitacion_censista"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.capacitacion_censista &&
                          _vm.form.id_tipo_permiso == 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  !!_vm.primer_permiso_censo
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "text-xs-justify",
                                          attrs: {
                                            color: "blue",
                                            icon: "done",
                                            value: "true",
                                            outline: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                "Ya tiene creado el primer permiso de este tipo (Nro de papeleta:\n                  " +
                                                  _vm.primer_permiso_censo
                                                    .numero +
                                                  ", \n                  " +
                                                  _vm.primer_permiso_censo
                                                    .fecha_desde +
                                                  "-\n                  " +
                                                  _vm.primer_permiso_censo
                                                    .fecha_hasta +
                                                  " (" +
                                                  _vm.primer_permiso_censo
                                                    .dias +
                                                  ")dias), en el cual seleccionó la opción: " +
                                                  _vm.capacitacion_censista.filter(
                                                    function(ele) {
                                                      return (
                                                        ele.id ==
                                                        _vm.primer_permiso_censo
                                                          .id_parametro_permiso
                                                      )
                                                    }
                                                  )[0].valor
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.capacitacion_censista == 135
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "text-xs-justify",
                                          attrs: {
                                            color: "indigo",
                                            icon: "warning",
                                            value: "true",
                                            outline: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Se le otorga una (1) jornada laboral al personal que\n                habiendose capacitado fuera de horario laboral no fué\n                convocado por el INE para el día del empadronamiento D.S. 5097\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.capacitacion_censista == 136
                                    ? _c(
                                        "v-alert",
                                        {
                                          staticClass: "text-xs-justify",
                                          attrs: {
                                            color: "indigo",
                                            icon: "warning",
                                            value: "true",
                                            outline: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Se le otorga dos (2) jornadas laborales al personal que\n                participo efectivamente el día del empadronamiento como\n                agentes censales enel Censo de Población y Vivienda 2024 D.S.\n                5097\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          (_vm.form.fecha_fallecimiento &&
                            _vm.form.hora_fallecimiento &&
                            _vm.form.id_tipo_permiso == 6) ||
                          (_vm.form.fecha_matrimonio &&
                            _vm.form.id_tipo_permiso == 12) ||
                          (_vm.form.fecha_nacimiento &&
                            _vm.form.hora_nacimiento &&
                            _vm.form.id_tipo_permiso == 61)
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha salida",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.fecha_desde2,
                                      callback: function($$v) {
                                        _vm.fecha_desde2 = $$v
                                      },
                                      expression: "fecha_desde2"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso != 101 &&
                          _vm.form.id_tipo_permiso != 100 &&
                          _vm.form.id_tipo_permiso != 99 &&
                          _vm.form.id_tipo_permiso != 98 &&
                          _vm.form.id_tipo_permiso != 89 &&
                          _vm.form.id_tipo_permiso != 94 &&
                          _vm.form.id_tipo_permiso != 87 &&
                          _vm.form.id_tipo_permiso != 104 &&
                          _vm.form.id_tipo_permiso != 24 &&
                          _vm.form.id_tipo_permiso != 88 &&
                          _vm.form.id_tipo_permiso != 96 &&
                          _vm.form.id_tipo_permiso != 37 &&
                          _vm.form.id_tipo_permiso != 38 &&
                          _vm.form.id_tipo_permiso != 39 &&
                          _vm.form.id_tipo_permiso != 40 &&
                          _vm.form.id_tipo_permiso != 41 &&
                          _vm.form.id_tipo_permiso != 42 &&
                          _vm.form.id_tipo_permiso != 43 &&
                          _vm.form.id_tipo_permiso != 6 &&
                          _vm.form.id_tipo_permiso != 61 &&
                          _vm.form.id_tipo_permiso != 90 &&
                          _vm.form.id_tipo_permiso != 12 &&
                          _vm.form.id_tipo_permiso != 102 &&
                          _vm.form.id_tipo_permiso != 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha salida",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.calculaDiasHabiles()
                                      },
                                      input: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_desde", $$v)
                                      },
                                      expression: "form.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          [90, 5].includes(parseInt(_vm.form.id_tipo_permiso))
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha salida",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_desde", $$v)
                                      },
                                      expression: "form.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          [90, 5].includes(
                            parseInt(_vm.form.id_tipo_permiso)
                          ) &&
                          _vm.form.fecha_desde &&
                          _vm.form.dias_incapacidad
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha hasta",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      }
                                    },
                                    model: {
                                      value: _vm.fecha_resultante,
                                      callback: function($$v) {
                                        _vm.fecha_resultante = $$v
                                      },
                                      expression: "fecha_resultante"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 101 ||
                          _vm.form.id_tipo_permiso == 100 ||
                          _vm.form.id_tipo_permiso == 99 ||
                          _vm.form.id_tipo_permiso == 98 ||
                          _vm.form.id_tipo_permiso == 87 ||
                          _vm.form.id_tipo_permiso == 104 ||
                          _vm.form.id_tipo_permiso == 88 ||
                          _vm.form.id_tipo_permiso == 96 ||
                          _vm.form.id_tipo_permiso == 89 ||
                          (_vm.form.id_tipo_permiso >= 37 &&
                            _vm.form.id_tipo_permiso <= 43)
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.verificarCompensacion(true) &&
                                          _vm.calculaDiasHabiles()
                                      },
                                      input: function($event) {
                                        return _vm.verificarCompensacion(false)
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_desde", $$v)
                                      },
                                      expression: "form.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 94
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.tipos_omision,
                                      "item-value": "id",
                                      "item-text": "valor",
                                      label: "Tipo de omisión",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.id_tipo_omision,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_tipo_omision",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_tipo_omision"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 94
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha de omisión de marcado",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.calculaDiasHabiles()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_desde", $$v)
                                      },
                                      expression: "form.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 94 &&
                          _vm.form.id_tipo_omision == 2
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.permiso_omision,
                                      "item-value": function(val) {
                                        return val
                                      },
                                      "item-text": function(val) {
                                        return (
                                          val.tipo_permiso +
                                          " : " +
                                          val.fecha_desde +
                                          " , " +
                                          val.hora_desde +
                                          " - " +
                                          val.hora_hasta
                                        )
                                      },
                                      label:
                                        "Seleccionar permiso (omisión de marcado)",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerHorarioLaboral()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_permiso_omision,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_permiso_omision",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_permiso_omision"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 94 &&
                          _vm.form.id_tipo_omision == 3
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.compensacion_omision,
                                      "item-value": function(val) {
                                        return val
                                      },
                                      "item-text": function(val) {
                                        return (
                                          val.tipo_permiso +
                                          " -" +
                                          val.numero +
                                          ": " +
                                          val.fecha_compensacion +
                                          " , " +
                                          val.hora_desde +
                                          " - " +
                                          val.hora_hasta
                                        )
                                      },
                                      label:
                                        "Seleccionar compensación (omisión de marcado)",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerHorarioLaboral()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_compensacion_omision,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_compensacion_omision",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_compensacion_omision"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 94 &&
                          _vm.form.id_tipo_omision == 4
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.compensacion_comisiones_viaje,
                                      "item-value": function(val) {
                                        return val
                                      },
                                      "item-text": function(val) {
                                        return (
                                          val.cite +
                                          " | " +
                                          _vm
                                            .$moment(val.fecha)
                                            .format("DD/MM/YYYY") +
                                          " | " +
                                          val.hora
                                        )
                                      },
                                      label:
                                        "Seleccionar comisión de viaje (omisión de marcado)",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerHorarioLaboral()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_compensacion_omision,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_compensacion_omision",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_compensacion_omision"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.form.fecha_fallecimiento &&
                            _vm.form.hora_fallecimiento &&
                            _vm.form.id_tipo_permiso == 6) ||
                          (_vm.form.fecha_matrimonio &&
                            _vm.form.id_tipo_permiso == 12) ||
                          (_vm.form.fecha_nacimiento &&
                            _vm.form.hora_nacimiento &&
                            _vm.form.id_tipo_permiso == 61)
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha hasta",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.fecha_hasta2,
                                      callback: function($$v) {
                                        _vm.fecha_hasta2 = $$v
                                      },
                                      expression: "fecha_hasta2"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 102
                            ? _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.calculaHorarioDiscontinuo()
                                      }
                                    },
                                    model: {
                                      value: _vm.fecha_trabajo_continuo,
                                      callback: function($$v) {
                                        _vm.fecha_trabajo_continuo = $$v
                                      },
                                      expression: "fecha_trabajo_continuo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 102
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      label: "Motivo",
                                      type: "text",
                                      rules: _vm.$validate(["required"]),
                                      maxlength: "500",
                                      required: "",
                                      "auto-grow": "",
                                      rows: "2",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.motivo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "motivo", $$v)
                                      },
                                      expression: "form.motivo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso != 101 &&
                          _vm.form.id_tipo_permiso != 100 &&
                          _vm.form.id_tipo_permiso != 99 &&
                          _vm.form.id_tipo_permiso != 98 &&
                          _vm.form.id_tipo_permiso != 14 &&
                          _vm.form.id_tipo_permiso != 105 &&
                          _vm.form.id_tipo_permiso != 97 &&
                          _vm.form.id_tipo_permiso != 87 &&
                          _vm.form.id_tipo_permiso != 104 &&
                          _vm.form.id_tipo_permiso != 88 &&
                          _vm.form.id_tipo_permiso != 89 &&
                          _vm.form.id_tipo_permiso != 8 &&
                          _vm.form.id_tipo_permiso != 13 &&
                          _vm.form.id_tipo_permiso != 15 &&
                          _vm.form.id_tipo_permiso != 94 &&
                          _vm.form.id_tipo_permiso != 24 &&
                          _vm.form.id_tipo_permiso != 96 &&
                          _vm.form.id_tipo_permiso != 37 &&
                          _vm.form.id_tipo_permiso != 38 &&
                          _vm.form.id_tipo_permiso != 39 &&
                          _vm.form.id_tipo_permiso != 40 &&
                          _vm.form.id_tipo_permiso != 41 &&
                          _vm.form.id_tipo_permiso != 42 &&
                          _vm.form.id_tipo_permiso != 43 &&
                          _vm.form.id_tipo_permiso != 90 &&
                          _vm.form.id_tipo_permiso != 6 &&
                          _vm.form.id_tipo_permiso != 61 &&
                          _vm.form.id_tipo_permiso != 12 &&
                          _vm.form.id_tipo_permiso != 102 &&
                          _vm.form.id_tipo_permiso != 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha hasta",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.calculaDiasHabiles()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_hasta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_hasta", $$v)
                                      },
                                      expression: "form.fecha_hasta"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 45
                            ? _c("v-flex", [
                                _c("p", [
                                  _c("strong", [_vm._v("Total Días:")]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(this.dias_habiles) +
                                      "\n              "
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 45
                            ? _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: [
                                          function(v) {
                                            if (v == null) {
                                              return "El campo es obligatorio."
                                            }
                                            return true
                                          }
                                        ]
                                      },
                                      model: {
                                        value: _vm.radio_data_programacion,
                                        callback: function($$v) {
                                          _vm.radio_data_programacion = $$v
                                        },
                                        expression: "radio_data_programacion"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Todo el día",
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo mañana",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo tarde",
                                              value: 2
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 45
                        ? _c(
                            "v-layout",
                            [
                              _c("v-flex", { attrs: { md12: "" } }, [
                                _c("h4", [_vm._v("Fechas de reprogramacion")])
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 45
                        ? _c(
                            "v-layout",
                            [
                              _vm.form.id_tipo_permiso == 45
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          type: "date",
                                          label: "Fecha desde",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          outline: "",
                                          clearable: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.calculaDiasHabiles()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.form.fecha_desde_reprogramacion,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "fecha_desde_reprogramacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.fecha_desde_reprogramacion"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.id_tipo_permiso == 45
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          type: "date",
                                          label: "Fecha hasta",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          outline: "",
                                          clearable: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.calculaDiasHabiles()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.form.fecha_hasta_reprogramacion,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "fecha_hasta_reprogramacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.fecha_hasta_reprogramacion"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 45
                            ? _c("v-flex", [
                                _c("p", [
                                  _c("strong", [_vm._v("Total Días:")]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(this.dias_habiles) +
                                      "\n              "
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 45
                            ? _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: [
                                          function(v) {
                                            if (v == null) {
                                              return "El campo es obligatorio."
                                            }
                                            return true
                                          }
                                        ]
                                      },
                                      model: {
                                        value: _vm.radio_data_reprogramacion,
                                        callback: function($$v) {
                                          _vm.radio_data_reprogramacion = $$v
                                        },
                                        expression: "radio_data_reprogramacion"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Todo el día",
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo mañana",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo tarde",
                                              value: 2
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 102
                            ? _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora desde",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.hora_desde_trabajo_continuo,
                                      callback: function($$v) {
                                        _vm.hora_desde_trabajo_continuo = $$v
                                      },
                                      expression: "hora_desde_trabajo_continuo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso == 102
                            ? _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora hasta",
                                      disabled: "",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.hora_hasta_trabajo_continuo,
                                      callback: function($$v) {
                                        _vm.hora_hasta_trabajo_continuo = $$v
                                      },
                                      expression: "hora_hasta_trabajo_continuo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          [90, 5].includes(parseInt(_vm.form.id_tipo_permiso))
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      value: function(val) {
                                        return parseInt(val)
                                      },
                                      name: "dias_incapacidad",
                                      label:
                                        _vm.form.id_tipo_permiso == 90
                                          ? "Días de incapacidad"
                                          : _vm.form.id_tipo_permiso == 5
                                          ? "Dias a solicitar"
                                          : "",
                                      type: "number",
                                      autofocus: "",
                                      rules: [
                                        function(v) {
                                          return (
                                            v > 0 ||
                                            "Introduzca un valor mayor a 0"
                                          )
                                        }
                                      ],
                                      maxlength: "10",
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      },
                                      input: function($event) {
                                        return _vm.obtenerSiguienteFecha()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.dias_incapacidad,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "dias_incapacidad",
                                          $$v
                                        )
                                      },
                                      expression: "form.dias_incapacidad"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 45
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.justificaciones_solicitud,
                                      "item-value": "descripcion",
                                      "item-text": "descripcion",
                                      label: "Justificacion de la solicitud",
                                      maxlength: "150",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.justificacion_solicitud,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "justificacion_solicitud",
                                          $$v
                                        )
                                      },
                                      expression: "form.justificacion_solicitud"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.justificacion_solicitud == "Otros"
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-textarea", {
                                    attrs: {
                                      label: "Otros",
                                      maxlength: "150",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso != 101 &&
                          _vm.form.id_tipo_permiso != 100 &&
                          _vm.form.id_tipo_permiso != 99 &&
                          _vm.form.id_tipo_permiso != 98 &&
                          _vm.form.id_tipo_permiso != 61 &&
                          _vm.form.id_tipo_permiso != 6 &&
                          _vm.form.id_tipo_permiso != 12 &&
                          _vm.form.id_tipo_permiso != 14 &&
                          _vm.form.id_tipo_permiso != 105 &&
                          _vm.form.id_tipo_permiso != 89 &&
                          _vm.form.id_tipo_permiso != 15 &&
                          _vm.form.id_tipo_permiso != 13 &&
                          _vm.form.id_tipo_permiso != 17 &&
                          _vm.form.id_tipo_permiso != 16 &&
                          _vm.form.id_tipo_permiso != 90 &&
                          _vm.form.id_tipo_permiso != 18 &&
                          _vm.form.id_tipo_permiso != 24 &&
                          _vm.form.id_tipo_permiso != 94 &&
                          _vm.form.id_tipo_permiso != 95 &&
                          _vm.form.id_tipo_permiso != 37 &&
                          _vm.form.id_tipo_permiso != 38 &&
                          _vm.form.id_tipo_permiso != 39 &&
                          _vm.form.id_tipo_permiso != 40 &&
                          _vm.form.id_tipo_permiso != 41 &&
                          _vm.form.id_tipo_permiso != 42 &&
                          _vm.form.id_tipo_permiso != 43 &&
                          _vm.form.id_tipo_permiso != 44 &&
                          _vm.form.id_tipo_permiso != 45 &&
                          _vm.form.id_tipo_permiso != 102 &&
                          _vm.form.id_tipo_permiso != 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora desde",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.validaPermisoPersonalGoce()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.hora_desde,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "hora_desde", $$v)
                                      },
                                      expression: "form.hora_desde"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.id_tipo_permiso != 101 &&
                          _vm.form.id_tipo_permiso != 100 &&
                          _vm.form.id_tipo_permiso != 99 &&
                          _vm.form.id_tipo_permiso != 98 &&
                          _vm.form.id_tipo_permiso != 61 &&
                          _vm.form.id_tipo_permiso != 6 &&
                          _vm.form.id_tipo_permiso != 12 &&
                          _vm.form.id_tipo_permiso != 14 &&
                          _vm.form.id_tipo_permiso != 105 &&
                          _vm.form.id_tipo_permiso != 89 &&
                          _vm.form.id_tipo_permiso != 15 &&
                          _vm.form.id_tipo_permiso != 13 &&
                          _vm.form.id_tipo_permiso != 17 &&
                          _vm.form.id_tipo_permiso != 16 &&
                          _vm.form.id_tipo_permiso != 90 &&
                          _vm.form.id_tipo_permiso != 18 &&
                          _vm.form.id_tipo_permiso != 24 &&
                          _vm.form.id_tipo_permiso != 94 &&
                          _vm.form.id_tipo_permiso != 95 &&
                          _vm.form.id_tipo_permiso != 37 &&
                          _vm.form.id_tipo_permiso != 38 &&
                          _vm.form.id_tipo_permiso != 39 &&
                          _vm.form.id_tipo_permiso != 40 &&
                          _vm.form.id_tipo_permiso != 41 &&
                          _vm.form.id_tipo_permiso != 42 &&
                          _vm.form.id_tipo_permiso != 43 &&
                          _vm.form.id_tipo_permiso != 44 &&
                          _vm.form.id_tipo_permiso != 45 &&
                          _vm.form.id_tipo_permiso != 102 &&
                          _vm.form.id_tipo_permiso != 5
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido-border",
                                    attrs: {
                                      type: "time",
                                      label: "Hora hasta",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.validaPermisoPersonalGoce()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.hora_hasta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "hora_hasta", $$v)
                                      },
                                      expression: "form.hora_hasta"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso >= 37 &&
                          _vm.form.id_tipo_permiso <= 43
                            ? _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: [
                                          function(v) {
                                            if (v == null) {
                                              return "El campo es obligatorio."
                                            }
                                            return true
                                          }
                                        ]
                                      },
                                      model: {
                                        value: _vm.radio_data,
                                        callback: function($$v) {
                                          _vm.radio_data = $$v
                                        },
                                        expression: "radio_data"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Mañana",
                                              value: "toda-mañana"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Tarde",
                                              value: "toda-tarde"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 12 ||
                      _vm.form.id_tipo_permiso == 97 ||
                      _vm.form.id_tipo_permiso == 87 ||
                      _vm.form.id_tipo_permiso == 104 ||
                      _vm.form.id_tipo_permiso == 103 ||
                      _vm.form.id_tipo_permiso == 90 ||
                      _vm.form.id_tipo_permiso == 61 ||
                      _vm.form.id_tipo_permiso == 6 ||
                      _vm.form.id_tipo_permiso == 95 ||
                      _vm.form.id_tipo_permiso == 44 ||
                      (_vm.form.id_tipo_permiso >= 37 &&
                        _vm.form.id_tipo_permiso <= 43)
                        ? _c("p")
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 97 ||
                          _vm.form.id_tipo_permiso == 87 ||
                          _vm.form.id_tipo_permiso == 104
                            ? _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                                _c(
                                  "div",
                                  {
                                    class:
                                      this.file == ""
                                        ? "archivo_vacio"
                                        : "archivo_cargado"
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          this.file == ""
                                            ? "file_upload"
                                            : "done"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "file",
                                      staticClass: "input-file",
                                      attrs: {
                                        type: "file",
                                        accept: "application/pdf"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleFileUpload()
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          this.file == "" &&
                                            _vm.form.id_tipo_permiso == 90
                                            ? "Adjuntar baja médica emitida por el ente gestor de salud"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 44
                                            ? "Adjuntar informe emitido por la URH y respaldos"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 6
                                            ? "Adjuntar certificado de defuncion emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso >= 37 &&
                                              _vm.form.id_tipo_permiso <= 43
                                            ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 12
                                            ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 61
                                            ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso != 90 &&
                                              _vm.form.id_tipo_permiso != 12 &&
                                              _vm.form.id_tipo_permiso != 61 &&
                                              _vm.form.id_tipo_permiso != 44 &&
                                              _vm.form.id_tipo_permiso != 37 &&
                                              _vm.form.id_tipo_permiso != 38 &&
                                              _vm.form.id_tipo_permiso != 39 &&
                                              _vm.form.id_tipo_permiso != 40 &&
                                              _vm.form.id_tipo_permiso != 41 &&
                                              _vm.form.id_tipo_permiso != 43 &&
                                              _vm.form.id_tipo_permiso != 42
                                            ? "Adjuntar respaldo"
                                            : this.file.name
                                        ) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.errors.denied
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Formato no admitido por el sistema\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 12 ||
                          _vm.form.id_tipo_permiso == 18 ||
                          _vm.form.id_tipo_permiso == 8 ||
                          _vm.form.id_tipo_permiso == 103 ||
                          _vm.form.id_tipo_permiso == 5
                            ? _c("v-flex", { attrs: { xs12: "" } }, [
                                _c(
                                  "div",
                                  {
                                    class:
                                      this.file == ""
                                        ? "archivo_vacio"
                                        : "archivo_cargado"
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          this.file == ""
                                            ? "file_upload"
                                            : "done"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "file",
                                      staticClass: "input-file",
                                      attrs: {
                                        type: "file",
                                        accept: "application/pdf",
                                        rules: _vm.$validate(["required"]),
                                        required: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleFileUpload2()
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          this.file == "" &&
                                            _vm.form.id_tipo_permiso == 90
                                            ? "Adjuntar baja médica emitida por el ente gestor de salud"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 44
                                            ? "Adjuntar informe emitido por la URH y respaldos"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 5 &&
                                              _vm.form.capacitacion_censista ==
                                                135
                                            ? "Adjuntar certificado que acredite la capacitación"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 5 &&
                                              _vm.form.capacitacion_censista ==
                                                136
                                            ? "Adjuntar certificado que acredite la participación activa al CENSO"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 6
                                            ? "Adjuntar certificado de defuncion emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso >= 37 &&
                                              _vm.form.id_tipo_permiso <= 43
                                            ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 12
                                            ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 61
                                            ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 8
                                            ? "ADJUNTAR JUSTIFICATIVO"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso != 90 &&
                                              _vm.form.id_tipo_permiso != 12 &&
                                              _vm.form.id_tipo_permiso != 8 &&
                                              _vm.form.id_tipo_permiso != 61 &&
                                              _vm.form.id_tipo_permiso != 44 &&
                                              _vm.form.id_tipo_permiso != 37 &&
                                              _vm.form.id_tipo_permiso != 38 &&
                                              _vm.form.id_tipo_permiso != 39 &&
                                              _vm.form.id_tipo_permiso != 40 &&
                                              _vm.form.id_tipo_permiso != 41 &&
                                              _vm.form.id_tipo_permiso != 43 &&
                                              _vm.form.id_tipo_permiso != 42
                                            ? "Adjuntar respaldo"
                                            : this.file.name
                                        ) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.errors2.file
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Debe seleccionar un archivo\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errors2.denied
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Formato no admitido por el sistema\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _vm.form.id_tipo_permiso == 6 ||
                          _vm.form.id_tipo_permiso == 61 ||
                          _vm.form.id_tipo_permiso == 95 ||
                          _vm.form.id_tipo_permiso == 44 ||
                          _vm.form.id_tipo_permiso == 90 ||
                          (_vm.form.id_tipo_permiso >= 37 &&
                            _vm.form.id_tipo_permiso <= 43)
                            ? _c("v-flex", { attrs: { xs12: "" } }, [
                                _c(
                                  "div",
                                  {
                                    class:
                                      this.file == ""
                                        ? "archivo_vacio"
                                        : "archivo_cargado"
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          this.file == ""
                                            ? "file_upload"
                                            : "done"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "file",
                                      staticClass: "input-file",
                                      attrs: {
                                        type: "file",
                                        accept: "application/pdf",
                                        rules: _vm.$validate(["required"]),
                                        required: "",
                                        outline: "",
                                        clearable: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.handleFileUpload2()
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          this.file == "" &&
                                            _vm.form.id_tipo_permiso == 90
                                            ? "Adjuntar baja médica emitida por el ente gestor de salud"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 44
                                            ? "Adjuntar informe emitido por la URH y respaldos"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 6
                                            ? "Adjuntar certificado de defuncion emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso >= 37 &&
                                              _vm.form.id_tipo_permiso <= 43
                                            ? "Adjuntar formulario otorgado por el servicio médico (Art. 3 Decreto supremo Nº 3164)"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 12
                                            ? "Adjuntar certificado de matrimonio emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso == 61
                                            ? "Adjuntar el certificado de nacimiento emitido por el registro civil"
                                            : this.file == "" &&
                                              _vm.form.id_tipo_permiso != 90 &&
                                              _vm.form.id_tipo_permiso != 12 &&
                                              _vm.form.id_tipo_permiso != 61 &&
                                              _vm.form.id_tipo_permiso != 44 &&
                                              _vm.form.id_tipo_permiso != 37 &&
                                              _vm.form.id_tipo_permiso != 38 &&
                                              _vm.form.id_tipo_permiso != 39 &&
                                              _vm.form.id_tipo_permiso != 40 &&
                                              _vm.form.id_tipo_permiso != 41 &&
                                              _vm.form.id_tipo_permiso != 43 &&
                                              _vm.form.id_tipo_permiso != 42
                                            ? "Adjuntar respaldo"
                                            : this.file.name
                                        ) +
                                        "\n              "
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.errors2.file
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Debe seleccionar un archivo\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errors2.denied
                                  ? _c(
                                      "p",
                                      { staticClass: "red--text body-1" },
                                      [
                                        _vm._v(
                                          "\n                *Formato no admitido por el sistema\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.hora_hasta != null &&
                      _vm.form.hora_desde != null &&
                      _vm.form.fecha_desde != null &&
                      (_vm.form.id_tipo_permiso == 14 ||
                        _vm.form.id_tipo_permiso == 105)
                        ? _c("v-flex", [
                            _c("p", [
                              _c("strong", [_vm._v("Total Horas:")]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.form.hora_hasta, "hh:mm")
                                      .subtract(_vm.form.hora_desde, "hh:mm")
                                      .format("hh:mm")
                                  ) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 18
                        ? _c("v-flex", [
                            _c("p", [
                              _c("strong", [_vm._v("Total Días:")]),
                              _vm._v(
                                _vm._s(this.dias) +
                                  "\n              " +
                                  _vm._s(this.dias_habiles) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 94
                        ? _c(
                            "v-layout",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _vm.form.id_tipo_omision == 2
                                    ? _c(
                                        "v-radio-group",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.obtenerHorarioLaboral()
                                            }
                                          },
                                          model: {
                                            value: _vm.form.tipo_horario,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "tipo_horario",
                                                $$v
                                              )
                                            },
                                            expression: "form.tipo_horario"
                                          }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Salida",
                                              value: "2"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Retorno",
                                              value: "1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _vm.form.id_tipo_omision == 1 &&
                                  _vm.form.fecha_desde
                                    ? _c(
                                        "v-radio-group",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.obtenerHorarioLaboral()
                                            }
                                          },
                                          model: {
                                            value: _vm.form.tipo_dia,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "tipo_dia",
                                                $$v
                                              )
                                            },
                                            expression: "form.tipo_dia"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Mañana",
                                                  value: "1"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Tarde",
                                                  value: "2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _vm.form.id_tipo_omision == 1 &&
                                  _vm.form.fecha_desde
                                    ? _c(
                                        "v-radio-group",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.obtenerHorarioLaboral()
                                            }
                                          },
                                          model: {
                                            value: _vm.form.tipo_horario,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "tipo_horario",
                                                $$v
                                              )
                                            },
                                            expression: "form.tipo_horario"
                                          }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Ingreso",
                                              value: "1"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Salida",
                                              value: "2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 13 ||
                      _vm.form.id_tipo_permiso == 15
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    row: "",
                                    rules: [
                                      function(v) {
                                        if (v == null) {
                                          return "El campo es obligatorio."
                                        }
                                        return true
                                      }
                                    ]
                                  },
                                  model: {
                                    value: _vm.radio_data,
                                    callback: function($$v) {
                                      _vm.radio_data = $$v
                                    },
                                    expression: "radio_data"
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Solo mañana",
                                          value: "toda-mañana"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Solo tarde",
                                          value: "toda-tarde"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 14 ||
                          _vm.form.id_tipo_permiso == 105
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md12: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: [
                                          function(v) {
                                            if (v == null) {
                                              return "El campo es obligatorio."
                                            }
                                            return true
                                          }
                                        ]
                                      },
                                      model: {
                                        value: _vm.radio_data,
                                        callback: function($$v) {
                                          _vm.radio_data = $$v
                                        },
                                        expression: "radio_data"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Todo el día",
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo mañana",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo tarde",
                                              value: 2
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 101 ||
                          _vm.form.id_tipo_permiso == 100 ||
                          _vm.form.id_tipo_permiso == 99 ||
                          _vm.form.id_tipo_permiso == 98 ||
                          _vm.form.id_tipo_permiso == 89
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: _vm.$validate(["required"]),
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.radio_data,
                                        callback: function($$v) {
                                          _vm.radio_data = $$v
                                        },
                                        expression: "radio_data"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo mañana",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo tarde",
                                              value: 2
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _vm.form.id_tipo_permiso == 94
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "time",
                                      label: "Hora",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.hora_calculada,
                                      callback: function($$v) {
                                        _vm.hora_calculada = $$v
                                      },
                                      expression: "hora_calculada"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout", [
                        _vm.form.id_tipo_permiso == 94
                          ? _c("p", [
                              _c("strong", [_vm._v("Nota.-")]),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  "Se le recomienda tener mayor cuidado y responsabilidad,\n                debido a que su reincidencia sera sancionada de acuerdo al\n                Reglamento Interno de Personal."
                                )
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      false
                        ? _c("v-layout", [
                            _vm.form.id_tipo_permiso == 8
                              ? _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      "Usted cuenta con 25 min. de tolerancia antes y\n                despues"
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso != 24
                        ? _c(
                            "v-flex",
                            [
                              (_vm.form.id_tipo_permiso != 96 &&
                                _vm.form.id_tipo_permiso != 8 &&
                                _vm.form.id_tipo_permiso != 12 &&
                                _vm.form.id_tipo_permiso != 18 &&
                                !_vm.bandera_compensacion &&
                                _vm.bandera_media_hora &&
                                !_vm.bandera_8horas) ||
                              _vm.form.id_tipo_permiso == 94 ||
                              ((_vm.form.id_tipo_permiso == 8 ||
                                _vm.form.id_tipo_permiso == 12 ||
                                _vm.form.id_tipo_permiso == 18 ||
                                _vm.form.id_tipo_permiso == 103 ||
                                _vm.form.id_tipo_permiso == 6 ||
                                _vm.form.id_tipo_permiso == 61 ||
                                _vm.form.id_tipo_permiso == 95 ||
                                _vm.form.id_tipo_permiso == 44 ||
                                _vm.form.id_tipo_permiso == 90 ||
                                (_vm.form.id_tipo_permiso >= 37 &&
                                  _vm.form.id_tipo_permiso <= 43)) &&
                                (!_vm.file || _vm.file != ""))
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        loading: _vm.loading_boton
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.save()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("save")]),
                                      _vm._v(
                                        "\n              Guardar\n            "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getRuta() == _vm.getPersonaId() &&
                              !_vm.bandera_compensacion &&
                              _vm.form.id_tipo_permiso != 96
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "error",
                                        to:
                                          "/permisos/usuario/" +
                                          _vm.getPersonaId()
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("clear")]),
                                      _vm._v(
                                        "\n              Cancelar\n            "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.id_tipo_permiso == 24
                        ? _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "success" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.crearPermisoCargoVacacion()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("arrow_downward")]),
                                  _vm._v(
                                    "\n              Continuar\n            "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.bandera_compensacion &&
          _vm.bandera_media_hora &&
          !_vm.bandera_8horas &&
          _vm.form.id_tipo_permiso == 88
            ? _c("compensacion", {
                attrs: {
                  item: _vm.form,
                  horas_compensacion: _vm.horas_compensacion,
                  ruta_ar: _vm.file,
                  estado_a: _vm.estado_a
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.id_tipo_permiso == 96 && _vm.bandera_media_hora
            ? _c("compensacion-tolerancia", {
                attrs: {
                  item: _vm.form,
                  id_persona: _vm.id_persona_permiso,
                  rol: 42
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f77b51c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f77b51c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/PermisoCrear.vue
// module id = null
// module chunks = 